import React from 'react';
import BankIdGreenIcon from '@resurs/styx/lib/images/icon-bank-id-green.svg';
import BankIdWhiteIcon from '@resurs/styx/lib/images/icon-bank-id-white.svg';
import CheckmarkGreenIcon from '@resurs/styx/lib/images/icon-checkmark-green.svg';
import CloneBlackIcon from '@resurs/styx/lib/images/icon-clone-black.svg';
import QRGreenIcon from '@resurs/styx/lib/images/icon-qr-green.svg';
import QRWhiteIcon from '@resurs/styx/lib/images/icon-qr-white.svg';
import styles from './Icon.module.scss';
export var IconVariant;
(function (IconVariant) {
    IconVariant["BankIdWhite"] = "bank_id_white";
    IconVariant["BankIdGreen"] = "bank_id_green";
    IconVariant["CheckmarkGreen"] = "checkmark_green";
    IconVariant["CloneBlack"] = "clone_black";
    IconVariant["QRCodeWhite"] = "qr_code_white";
    IconVariant["QRCodeGreen"] = "qr_code_green";
})(IconVariant || (IconVariant = {}));
const Icons = {
    [IconVariant.BankIdGreen]: BankIdGreenIcon,
    [IconVariant.BankIdWhite]: BankIdWhiteIcon,
    [IconVariant.CheckmarkGreen]: CheckmarkGreenIcon,
    [IconVariant.CloneBlack]: CloneBlackIcon,
    [IconVariant.QRCodeGreen]: QRGreenIcon,
    [IconVariant.QRCodeWhite]: QRWhiteIcon,
};
const Icon = ({ variant, svg, size }) => {
    var _a;
    return (variant || svg) && (React.createElement("div", { style: {
            backgroundImage: `url(${(_a = Icons[variant]) !== null && _a !== void 0 ? _a : svg})`,
            minWidth: size === null || size === void 0 ? void 0 : size.width,
            minHeight: size === null || size === void 0 ? void 0 : size.height,
        }, className: styles.icon }));
};
export default Icon;
